// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3lOdr","upload":"Small_upload__2cklu","imageWrap":"Small_imageWrap__jw9Ti","removeBtn":"Small_removeBtn__uUJ8c"};